import React from "react";
import stylesLess from "./index.module.less";

export default function FormItem({ title, errMsg, children, style }) {
  return (
    <div className={`${stylesLess.main}`} style={style}>
      {title && <div className="iTitle">{title}</div>}
      {children && <div className="iBody">{children}</div>}
      {/*{errMsg && <div className="iErrMsg">{errMsg}</div>}*/}
      <div className="iErrMsg">{errMsg || ""}</div>
    </div>
  );
}
